// extracted by mini-css-extract-plugin
module.exports = {"containerScrollbar":"styles_containerScrollbar__jy4OE","cuadraditoActive":"styles_cuadraditoActive__vWNuI","cuadradito":"styles_cuadradito__sgieF"};